import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Link, useParams } from "react-router-dom"
import { bindActionCreators } from "redux"
import { callLocationViewGet, callLocationPost, callLocationPut, callLocationClearView } from "../../actions/locations"
import { callCompanySelectGet } from "../../actions/companies"
import { callLocationCategorySelectGet } from "../../../config/actions/locationCategories"
import { callRegionSelectGet } from "../../../config/actions/regions"

let LocationEdit = ({ 
    setPageAttr, 
    methods: { 
        callLocationPost, 
        callLocationViewGet, 
        callLocationPut, 
        callLocationClearView, 
        callCompanySelectGet, 
        callLocationCategorySelectGet, 
        callRegionSelectGet 
    }, 
    view, 
    companiesSelect, 
    locationCategoriesSelect, 
    regionsSelect 
}) => {
    const params = useParams()
    const [id] = useState(!params.id ? '' : params.id)
    const [companyId, setCompanyId] = useState('')
    const [categoryId, setCategoryId] = useState('')
    const [regionId, setRegionId] = useState('')
    const [code, setCode] = useState('')
    const [name, setName] = useState('')

    useEffect(() => {
        callLocationCategorySelectGet()
        callCompanySelectGet()
        callRegionSelectGet()
        callLocationClearView()
        let tabs
        if (!id) {
            tabs = [
                {
                    active: false,
                    to: '/locations',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/locations/add',
                    label: 'Adicionar'
                }
            ]
        } else {
            callLocationViewGet(id)
            tabs = [
                {
                    active: false,
                    to: '/locations',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/locations/edit/' + id,
                    label: 'Editar'
                }
            ]
        }

        setPageAttr({
            title: 'Local - ' + (!id ? 'Novo' : 'Editar'),
            caption: 'Preencha os campos para inserir as informações',
            btns: [],
            tabs: tabs
        })
    }, [setPageAttr, id, callLocationViewGet, callLocationClearView, callCompanySelectGet, callLocationCategorySelectGet, callRegionSelectGet])

    useEffect(() => {
        setCompanyId(view.companyId.toString())
        setCategoryId(view.categoryId.toString())
        setRegionId(view.regionId.toString())
        setCode(view.code)
        setName(view.name)
    }, [view])

    const finishedSubmit = () => {
        setCompanyId('')
        setCategoryId('')
        setRegionId('')
        setCode('')
        setName('')
        window.navigate('/locations')
    }

    const submit = (e) => {
        e.preventDefault()

        let data = {
            companyId: parseInt(companyId),
            categoryId: parseInt(categoryId),
            regionId: parseInt(regionId),
            code,
            name,
        }

        if (!id) {
            callLocationPost(data, () => finishedSubmit())
        } else {
            callLocationPut(id, data, () => finishedSubmit())
        }
    }

    return (
        <form onSubmit={submit}>
            <div className="form-row">
                <div className="col-md-12">
                    <div className="form-row">
                        <div className="col-md-6 form-group">
                            <label className="required">Código:</label>
                            <input type="text" className="form-control" value={code} onChange={e => setCode(e.target.value)} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label className="required">Nome:</label>
                            <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label className="required">Empresa:</label>
                            <select className="form-control" value={companyId} onChange={e => setCompanyId(e.target.value)}>
                                <option value=''>Selecione</option>
                                {companiesSelect.map((a, ai) => (
                                    <option key={ai} value={a.id}>{a.description}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6 form-group">
                            <label className="required">Tipo:</label>
                            <select className="form-control" value={categoryId} onChange={e => setCategoryId(e.target.value)}>
                                <option value=''>Selecione</option>
                                {locationCategoriesSelect.map((a, ai) => (
                                    <option key={ai} value={a.id}>{a.description}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6 form-group">
                            <label className="required">Região:</label>
                            <select className="form-control" value={regionId} onChange={e => setRegionId(e.target.value)}>
                                <option value=''>Selecione</option>
                                {regionsSelect.map((a, ai) => (
                                    <option key={ai} value={a.id}>{a.description}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix text-left mt-3">
                <button className="btn btn-primary" type="submit"><i className="mr-1 fas fa-save fa-white"></i>Salvar</button>
                <Link to={'/locations'} className="btn btn-secondary ml-3"><i className="fas fa-arrow-left mr-1"></i>Voltar</Link>
            </div>
        </form>
    )
}

const mapStateToProps = ({ register: { locations: { view }, companies }, config: { locationCategories, regions } }) => ({
    view: view,
    companiesSelect: companies.select,
    locationCategoriesSelect: locationCategories.select,
    regionsSelect: regions.select
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callLocationViewGet,
            callLocationPost,
            callLocationClearView,
            callLocationPut,
            callCompanySelectGet,
            callLocationCategorySelectGet,
            callRegionSelectGet
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationEdit)